export const config = {
  // Firebase FUD WORKS Config Info
  apiKey: 'AIzaSyD_fXvD4LGPGatE53XHDZl93EMlFyNx64c',
  authDomain: 'btr.works',
  databaseURL: 'https://btrworkscom.firebaseio.com',
  projectId: 'btrworkscom',
  storageBucket: 'btrworkscom.appspot.com',
  messagingSenderId: '1050456545258'
}



// WEBPACK FOOTER //
// ./src/helpers/firebaseConfig.js